function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react/no-danger */
import React, { useState } from "react";
import ReactTooltip from "react-tooltip";
import PropTypes from "prop-types";
import { selectDictionary, selectData } from "../utils/prop-types";
import Overlay from "./overlay";
import HelpText from "./help-text";
import DropDown from "./dropdown";
import getFromDictionary from "../utils/dictionary";
var Select = function Select(_ref) {
  var _dictionary$dropdown;
  var dictionary = _ref.dictionary,
    data = _ref.data,
    onChange = _ref.onChange,
    value = _ref.value,
    type = _ref.type,
    showDirect = _ref.showDirect,
    setDirect = _ref.setDirect,
    _ref$showTwoWayStream = _ref.showTwoWayStreaming,
    showTwoWayStreaming = _ref$showTwoWayStream === void 0 ? false : _ref$showTwoWayStream,
    setTwoWayStreaming = _ref.setTwoWayStreaming,
    selectDeviceDictionary = _ref.selectDeviceDictionary,
    disableDirectStreaming = _ref.disableDirectStreaming,
    hideCheckbox = _ref.hideCheckbox;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showHelp = _useState2[0],
    setShowHelp = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showSecondaryHelp = _useState4[0],
    setShowSecondaryHelp = _useState4[1];
  var isAdditionalFeature = type === 'additionalFeature';
  var handleHelpClick = function handleHelpClick(evt) {
    evt.preventDefault();
    setShowHelp(true);
  };
  var handleSecondaryHelpClick = function handleSecondaryHelpClick(evt) {
    evt.preventDefault();
    setShowSecondaryHelp(true);
  };
  var handleHelpClose = function handleHelpClose() {
    setShowHelp(false);
    setShowSecondaryHelp(false);
  };
  var dropdownTitle = dictionary === null || dictionary === void 0 || (_dictionary$dropdown = dictionary.dropdown) === null || _dictionary$dropdown === void 0 ? void 0 : _dictionary$dropdown.html.html.trim();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "cg__select ".concat(type)
  }, dictionary.headline && /*#__PURE__*/React.createElement("div", {
    className: "cg__title",
    dangerouslySetInnerHTML: {
      __html: dictionary.headline.html.html
    }
  }), dictionary.description && /*#__PURE__*/React.createElement("div", {
    className: "cg__description",
    dangerouslySetInnerHTML: {
      __html: dictionary.description.html.html
    }
  }), dropdownTitle && (data === null || data === void 0 ? void 0 : data.length) && /*#__PURE__*/React.createElement(DropDown, {
    type: type,
    onChange: onChange,
    value: value,
    options: [{
      id: type === 'products' ? 0 : '',
      title: dropdownTitle
    }].concat(_toConsumableArray(data)).map(function (item) {
      return {
        value: item.id,
        label: item.title,
        subTitle: item.subTitle
      };
    })
  }), dictionary.helpLabel && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "button-modal",
    onClick: handleHelpClick
  }, dictionary.helpLabel.html.html), dictionary.secondaryHelpLabel && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "button-modal",
    onClick: handleSecondaryHelpClick
  }, dictionary.secondaryHelpLabel.html.html), !hideCheckbox && /*#__PURE__*/React.createElement("div", {
    className: "directStreaming-wrapper ".concat(type)
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "cg__checkbox-button direct_streaming ".concat(showDirect ? "cg__checkbox-button--selected" : "", " ").concat(!disableDirectStreaming ? "disabled" : ""),
    onClick: setDirect
  }, getFromDictionary("directStreaming", selectDeviceDictionary)), dictionary.directStreamingTooltipText && dictionary.directStreamingTooltipText.html.html.trim() && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    "data-tip": true,
    className: "cg__tooltip",
    "data-for": "direct-streaming-tooltip"
  }, "\uE900"), /*#__PURE__*/React.createElement(ReactTooltip, {
    place: "bottom",
    type: "light",
    backgroundColor: "white",
    textColor: "#3b3c3d",
    effect: "float",
    id: "direct-streaming-tooltip",
    isCapture: false,
    border: true,
    borderColor: "#D7D3CC"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cg__tooltip-content",
    dangerouslySetInnerHTML: {
      __html: dictionary.directStreamingTooltipText.html.html.trim()
    }
  })))), dictionary.twoWayStreaming && /*#__PURE__*/React.createElement("div", {
    className: "directStreaming-wrapper ".concat(type)
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "cg__checkbox-button direct_streaming ".concat(showTwoWayStreaming ? "cg__checkbox-button--selected" : "", " ").concat(!disableDirectStreaming ? "disabled" : ""),
    onClick: setTwoWayStreaming
  }, getFromDictionary("twoWayStreaming", selectDeviceDictionary)))), showHelp && /*#__PURE__*/React.createElement(Overlay, {
    onClose: handleHelpClose
  }, /*#__PURE__*/React.createElement(HelpText, {
    text: dictionary.helpText,
    link: dictionary.helpCTA,
    onClose: handleHelpClose
  })), showSecondaryHelp && /*#__PURE__*/React.createElement(Overlay, {
    onClose: handleHelpClose
  }, /*#__PURE__*/React.createElement(HelpText, {
    text: dictionary.secondaryHelpText,
    link: dictionary.secondaryHelpCTA,
    onClose: handleHelpClose
  })));
};
Select.propTypes = {
  dictionary: selectDictionary.isRequired,
  data: selectData,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired])
};
export default Select;